module.exports = __webpack_public_path__ + "img/gallery111.f03ec7b7.jpg";